import {Box, Occupancy} from "@variocube/app-api";
import {
    Avatar,
    Badge,
    PushButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    useBoxes,
    useOccupancies
} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {ClesyBoxType} from "../model";
import {CustomerCell} from "./common";
import {useLocalization} from "../../i18n";

interface WelcomePackageProps {
    onOpen: (boxNumber: string) => void;
    onStore: (boxNumber: string) => void;
}

export function WelcomePackageTable({onOpen, onStore}: WelcomePackageProps) {
    const {t} = useLocalization();
    const boxes = useBoxes();
    const welcomePackageBoxes = boxes.filter(box => box.types.indexOf(ClesyBoxType.WelcomePackage) >= 0);
    const occupancies = useOccupancies();

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>{t("Box")}</TableCell>
                    <TableCell>{t("Status")}</TableCell>
                    <TableCell>{t("Customer")}</TableCell>
                    <TableCell>{" "}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {welcomePackageBoxes?.map(box => {
                    const occupancy = occupancies.find(occupancy => occupancy.boxNumber == box.number);
                    return <BoxRow key={box.number} box={box} occupancy={occupancy} onOpen={onOpen} onStore={onStore}/>;
                })}
            </TableBody>
        </Table>
    );
}


interface BoxRowProps {
    box: Box;
    occupancy?: Occupancy;
    onStore: (boxNumber: string) => void;
    onOpen: (boxNumber: string) => void;
}

function BoxRow({box, occupancy, onStore, onOpen}: BoxRowProps) {
    //const strings = useStrings(resources);
    const {t} = useLocalization();
    const order = occupancy?.content?.order;

    const handleOpen = useCallback(() => onOpen(box.number), [onOpen, box]);
    const handleStore = useCallback(() => onStore(box.number), [onStore, box]);

    return (
        <TableRow>
            <TableCell>
                <Avatar size={1.5}>{box.number}</Avatar>
            </TableCell>
            <TableCell>
                <Badge success={!!occupancy} warning={!occupancy}>
                    {occupancy ? t("Present") : t("Empty")}
                </Badge>
            </TableCell>
            <CustomerCell order={order} />
            <TableCell>
                { occupancy && (
                    <PushButton primary onClick={handleOpen}>
                        {t("Open")}
                    </PushButton>
                )}
                { !occupancy && (
                    <PushButton primary onClick={handleStore}>
                        {t("Store")}
                    </PushButton>
                )}
            </TableCell>
        </TableRow>
    );
}
